import { get } from 'lodash-es';
import { CARE_CLIENT_VISITOR_STATE } from '@/interface/domain/careClientVisitor';
import { useRouter } from '@/util/hook/custom';
import useEffect from '@/util/hook/useEffect';
import useSelector from '@/util/hook/useSelector';
import { selectCareClientVisitorProfile } from '../../redux/module/careClientVisitorProfile';
import { selectIsCareClientVisitorProfileInitialized } from '../../redux/module/tracker';
import { APP } from '../../config/app';
export const useValidateCareClientVisitorProfileAndRedirect = ({ redirectRoute, }) => {
    const isCareClientVisitorProfileInitialized = useSelector(selectIsCareClientVisitorProfileInitialized);
    const careClientVisitorProfile = useSelector(selectCareClientVisitorProfile);
    const { navigate } = useRouter();
    const careClientVisitorState = get(careClientVisitorProfile, 'state');
    useEffect(() => {
        if (!isCareClientVisitorProfileInitialized)
            return;
        if (careClientVisitorState === CARE_CLIENT_VISITOR_STATE.END) {
            navigate(APP.ROUTES.TRANSFER_INSTRUCTION);
        }
        else if (redirectRoute) {
            navigate(redirectRoute);
        }
    }, [isCareClientVisitorProfileInitialized]);
};
